// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Polls/components/CurrentResultModal/index.css
// module id = 2352
// module chunks = 0